/* @flow */

import * as React from 'react';

import NotificationPortal from 'src/shared/app/notification/component/NotificationPortal';
import TakeOverPortal from 'src/shared/app/notification/component/TakeOverPortal';

type Props = {
  Switch: React.ComponentType<any>,
};

const BlankTemplate = ({ Switch }: Props): React.Node => (
  <>
    <NotificationPortal />
    <TakeOverPortal />

    <Switch />
  </>
);

export default React.memo<Props>(BlankTemplate);
